import React from 'react'
import { Grid, Skeleton } from 'gu-ui-kit'
import { useBreakpoint } from 'utils/hoc/breakpointProvider'

const Placeholder = () => {
  const breakpoint = useBreakpoint()
  return (
    <Skeleton shown>
      <Skeleton.Item
        width={'30%'}
        height={24}
        className={'margin-bottom-8'}
      />

      <Skeleton.Item
        width={'40%'}
        height={48}
        className={breakpoint.sm ? 'margin-bottom-24' : 'margin-bottom-40'}
      />
      <Grid
        gap={16}
        wrap={false}
      >
        <Skeleton.Item
          width={'100%'}
          height={48}
        />
        <Skeleton.Item
          width={'100%'}
          height={48}
        />
      </Grid>
    </Skeleton>
  )
}

export default Placeholder
